import { render, staticRenderFns } from "./ad-downloads-list.vue?vue&type=template&id=f0fabf3c"
import script from "./ad-downloads-list.vue?vue&type=script&lang=ts"
export * from "./ad-downloads-list.vue?vue&type=script&lang=ts"
import style0 from "./ad-downloads-list.vue?vue&type=style&index=0&id=f0fabf3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports